export default "__VITE_ASSET__BEm_cHjX__"